// extracted by mini-css-extract-plugin
export default {"tableOptions":"TableOptions_tableOptions__gLJEQ","marginBox":"TableOptions_marginBox__aM1EO"};